import { get, post, path_version } from '@/httpRequest/http'
import store from '@/store/purchasing'
import { getOrigin } from '@/utils/env'
const { VUE_APP_PURCHASING = '' } = process.env
import { getBaseUrl } from '@/utils'
const BASEURL = getBaseUrl(VUE_APP_PURCHASING)

export const getLimitIncreaseApplyStatus = subAccountId => {
    return get(`${BASEURL}/margin/${path_version}/LimitIncreaseApplyStatus`, {
        params: {
            subAccountId: subAccountId ?? store.state.user.subAccountId ?? '',
        },
    })
}
export const getMarginLimitResultConfirm = ({ id, subAccountId } = {}) => {
    return post(`${BASEURL}/margin/${path_version}/MarginLimitResultConfirm`, {
        data: {
            subAccountId: subAccountId ?? store.state.user.subAccountId ?? '',
            id,
        },
    })
}

export const getLimitAutoIncreaseStatus = ({ clientId } = {}) => {
    const cltId = localStorage.getItem('cltId') || '' //网厅使用
    const data = {
        clientId: +`${clientId ?? cltId ?? ''}`,
    }
    return get(`${BASEURL}/margin/${path_version}/LimitAutoIncreaseStatus`, {
        params: data,
    })
}

export const setLimitAutoIncrease = ({ clientId, status } = {}) => {
    const cltId = localStorage.getItem('cltId') || '' //网厅使用
    const data = {
        clientId: +`${clientId ?? cltId ?? ''}`,
        status,
    }

    return post(`${BASEURL}/margin/${path_version}/LimitAutoIncrease`, {
        data,
    })
}

export const limitIncreaseApply = ({ subAccountId, currentMarginLimit, applyMarginLimit, clientId, accountId, ossIds } = {}) => {
    const { clientInfo: { accts = [] } = {} } = store.state.user.userInfo ?? {}
    const [{ cltId, acctId } = {}] = accts

    const data = {
        subAccountId: subAccountId ?? store.state.user.subAccountId ?? '',
        currentMarginLimit,
        applyMarginLimit,
        ossIds: Array.isArray(ossIds) ? ossIds : [],
        origin: getOrigin(),
        clientId: `${clientId ?? cltId ?? ''}`,
        accountId: `${accountId ?? acctId ?? ''}`,
    }

    return post(`${BASEURL}/margin/${path_version}/LimitIncreaseApply`, {
        data,
    })
}

export const getAccountQuery = ({ subAccountId, clientId, accountId } = {}) => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const { clientInfo: { accts = [] } = {} } = userInfo ?? {}
    // const { clientInfo: { accts = [] } = {} } = store.state.user.userInfo ?? {}
    const [{ cltId, acctId } = {}] = accts

    const data = {
        subAccountId: subAccountId ?? store.state.user.subAccountId ?? '',
        clientId: `${clientId ?? cltId ?? ''}`,
        accountId: `${accountId ?? acctId ?? ''}`,
    }

    return get(`${BASEURL}/margin/${path_version}/AccountQuery`, {
        params: data,
    })
}

export const getSubAcctInfo = ({ subAccountId, clientId, accountId } = {}) => {
    const { clientInfo: { accts = [] } = {} } = store.state.user.userInfo ?? {}
    const [{ cltId, acctId } = {}] = accts

    const subAcctId = subAccountId || store.state.user.subAccountId || localStorage.getItem('sub') || ''
    const data = {
        subAcctId,
        subAccountId: subAcctId,
        clientId: `${clientId ?? cltId ?? ''}`,
        accountId: `${accountId ?? acctId ?? ''}`,
    }

    return get(`${BASEURL}/uc/${path_version}/SubAcctInfo`, {
        params: data,
    })
}
